// extracted by mini-css-extract-plugin
export default {"createGame":"CreateGame_createGame__yY2Lx","btnGroup":"CreateGame_btnGroup__Kul6c"};